import { render, staticRenderFns } from "./disassemb_detail.vue?vue&type=template&id=1453bea8&"
import script from "./disassemb_detail.vue?vue&type=script&lang=js&"
export * from "./disassemb_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports